<template>
  <HScaffold :title="params?.title" fillHeight>

    <iframe
        :src="params?.url"
        class="frameStyle"
        frameborder="0"
    ></iframe>

  </HScaffold>
</template>


<script setup>
  import {hr} from "@/components/utils/HRouter.js";
  import {log} from "@/components/utils/HComFunctions.js";
  let params = ref(hr.getRouteParams());
</script>


<style scoped>
  .frameStyle{
    width:100%;
    height:100%;
  }
</style>
